// http://wiki.sankuai.com/pages/viewpage.action?pageId=810465028
const venusAllows = ["w", "h", "e", "l", "c", "a", "m", "sc", "q", "Q"].reduce(function(r, a) {
  r[a] = true;
  return r;
}, {});
const mssAllows = ["w", "h", "e", "l", "p", "bgc", "c", "a", "rc", "r", "o", "q", "Q", "pr"].reduce(function(r, a) {
  r[a] = true;
  return r;
}, {});

const mssImageDomainMap = {
  "s3.meituan.net": "s3-img.meituan.net",
  "msstest.sankuai.com": "msstest-img.sankuai.com",
  "msstest.vip.sankuai.com": "msstest-img.vip.sankuai.com",
  "mss.sankuai.com": "mss-img.sankuai.com",
  "mss.vip.sankuai.com": "mss-img.vip.sankuai.com",
};

export function isVenusImage(url) {
  return /\/\/(p\d\.meituan\.(net|com)|img\.meituan\.net|vfile\.meituan\.net)\//i.test(url);
}

export function isMSSImage(url) {
  return /\/\/(msstest-img(\.vip)?\.sankuai\.com|mss-img(\.vip)?\.sankuai\.com|s3-img\.meituan\.net)\//i.test(url);
}

/**
 * @param url
 * @returns {string}
 */
export function toMSSImageUrlOrFallbackToOriginalUrl(url) {
  return (url || "").replace(
    /\/\/(msstest(?:\.vip)?\.sankuai\.com|mss(?:\.vip)?\.sankuai\.com|s3\.meituan\.net)\//,
    function(match, first) {
      if (first && mssImageDomainMap[first]) {
        return "//" + mssImageDomainMap[first] + "/";
      } else {
        return match;
      }
    }
  );
}

/**
 *
 * @param {String} originalUrl
 * @param {Array|Object} [processes]
 * @param {String} [ext]
 */
export default function meituanImageUrl(originalUrl, processors, ext) {
  if (!originalUrl) return originalUrl;
  let url = toMSSImageUrlOrFallbackToOriginalUrl(originalUrl);
  const venus = isVenusImage(url);
  const mss = isMSSImage(url);
  if (!(venus || mss)) return originalUrl;
  const typeofProcessors = typeof processors;
  if (typeofProcessors === "string") {
    ext = processors;
    processors = [];
  } else if (typeofProcessors === "object" && !Array.isArray(processors)) {
    ext = ext || processors.ext;
    processors = [processors];
  } else {
    processors = [];
  }

  // 优先显示 https 的图片
  if (venus || (mss && !/\.vip\.sankuai\.com/.test(url))) {
    url = url.replace(/^https?:/, "https:");
  }

  if (venus && ext === "webp") {
    url += ".webp";
  }

  const allows = venus ? venusAllows : mssAllows;

  let processString = processors
    .map(function(proc) {
      const converts = [];
      for (let key in proc) {
        if (proc.hasOwnProperty(key) && allows.hasOwnProperty(key)) {
          if (proc[key] === true) {
            converts.push(key);
          } else {
            let value = proc[key];
            if (key === "w" || key === "h" || key === "q") {
              value = parseInt(value, 10);
            }
            converts.push(value + key);
          }
        }
      }
      return converts.join("_");
    })
    .join("|");

  if (mss && ext) {
    processString += "." + ext;
  }

  if (processString) {
    url += "@" + processString;
  }
  return url;
}
